import React, { FC } from "react";

import { BoldText } from "components/BoldText/BoldText";

interface HeaderProps {
  title: string;
}

export const Header: FC<HeaderProps> = ({ title }): JSX.Element => (
  <div>
    <BoldText>{title}</BoldText>
  </div>
);
